import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {TranslationService} from '../../services/translation.service';
import {ToolsService} from '../../services/tools/tools.service';
import {QUILL_ADMIN_CONFIG} from '../../../core/consts/quill';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgClass, UpperCasePipe } from '@angular/common';
import { QuillModule } from 'ngx-quill';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-reouverture-dossier',
    templateUrl: './modal-reouverture-dossier.component.html',
    styleUrls: ['./modal-reouverture-dossier.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, NgClass, QuillModule, FormsModule, MatDialogActions, MatButton, MatDialogClose, UpperCasePipe, TranslateModule]
})
export class ModalReouvertureDossierComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<ModalReouvertureDossierComponent>>(MatDialogRef);
    translationService = inject(TranslationService);
    private toolService = inject(ToolsService);

    public modules = this.toolService.deepCloneQuill(QUILL_ADMIN_CONFIG);
    public text = '';

  constructor() {
      this.modules['counter'].container = '#reouverture-comment-counter';
  }

  ngOnInit(): void {
  }

    public getTitreTranslation() {
        return this.translationService.getPropertyTranslation(this.data.dossier, 'titre');
    }

}
